import { Path } from "../Path";
import { Point } from "../Point";
import { PointHelper } from "./PointHelper";

export class PathHelper {
  static getPointOnPath(path: Path, distanceFromFirstPoint: number): Point {
    const { distances, points } = path;
    let result: Point;

    // Find an exact match.
    const pointIndex = distances.findIndex((d) => d === distanceFromFirstPoint);

    if (pointIndex === -1) {
      const [first, second, distance] = PathHelper.getPointsSurroundingPointOnPath(
        path,
        distanceFromFirstPoint,
      );

      result = PointHelper.getPointBetweenPoints(first, second, distanceFromFirstPoint - distance);
    } else {
      result = points[pointIndex];
    }

    return result;
  }

  /**
   * Finds the points surrounding the point on the path. The distance from the first point is used to find the points.
   * If the distance does exceeds or is less than the length of the path, an error is thrown.
   * @param distanceFromFirstPoint
   * @returns The two points surrounding the point and the distance of the frist point to the first point of the Path.
   */
  static getPointsSurroundingPointOnPath(
    path: Path,
    distanceFromFirstPoint: number,
  ): [Point, Point, number] {
    const { distances, points } = path;

    if (points.length !== distances.length) {
      throw new Error("Points and distances must have the same length");
    }

    const result = distances.reduce<{
      point1?: Point;
      point2?: Point;
      distance?: number;
    }>((acc, distance, index, array) => {
      const nextDistance = array[index + 1];

      if (distanceFromFirstPoint >= distance && distanceFromFirstPoint <= nextDistance) {
        return {
          point1: points[index],
          point2: points[index + 1],
          distance: distance,
        };
      }
      return acc;
    }, {});

    if (!result.point1 || !result.point2 || result.distance === undefined) {
      throw new Error("Point not found on path");
    }

    return [result.point1, result.point2, result.distance];
  }
}
